module.exports = __webpack_public_path__ + "static/media/snow_falls.9b4cec54.gif";